/*
 * brand.js - Sets the title and colours to use
 */
'use strict';

Sao.config.title = 'Formex';
Sao.config.icon_colors = '#c09c2e,#777,#d9534f'.split(',');
